module.exports = __webpack_public_path__ + "static/media/icon-folder-slash.2c5f1a45.svg";